<template>
  <div class="h-100">
    <v-row class="h-100">
      <v-col class="h-25" cols="6">Running :</v-col>
      <v-col class="h-25 text-right" cols="6">
        <div class="h-75">
          <chart-running :value="running.value" :max="running.max" :animation="true" area-style="linearGradient" :contextmenu="onContextmenuChart" />
        </div>
      </v-col>
      <v-col class="h-75" cols="6">
        <v-row class="h-25">Status :</v-row>
        <v-row class="h-75 text-right">
          <v-col>
            <!--BEGIN::Modified.by.KWShin.2024.01.14.-->
            <!--chart-status :values="status.values" :colors="status.colors" :animation="true" area-style="linearGradient" :contextmenu="onContextmenuChart" /-->
            <chart-status ref="wpStatus" :values="status.values" :colors="status.colors" :animation="true" area-style="linearGradient" :contextmenu="onContextmenuChartNative" />
            <!--FINISH::Modified.by.KWShin.2024.01.14.-->
          </v-col>
        </v-row>
      </v-col>
      <v-col class="h-75" cols="6">
        <v-row class="h-25">Type :</v-row>
        <v-row class="h-75 text-right">
          <v-col>
            <!--BEGIN::Modified.by.KWShin.2024.01.14.-->
            <!--chart-type :values="type.values" :colors="type.colors" :animation="true" area-style="linearGradient" :contextmenu="onContextmenuChart" /-->
            <chart-type ref="wpType" :values="type.values" :colors="type.colors" :animation="true" area-style="linearGradient" :contextmenu="onContextmenuChartNative" />
            <!--FINISH::Modified.by.KWShin.2024.01.14.-->
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <contextmenu :options="contextmenuParam"></contextmenu>
    </v-row>
  </div>
</template>

<script>
import instanceable from './mixins/instanceable';
import contextmenuable from './mixins/contextmenuable';
import ChartRunning from '../chart/BarHorizontalSingle.vue';
import ChartStatus from '../chart/Pie.vue';
import ChartType from '../chart/Pie.vue';
import { isEmpty } from 'lodash';

export default {
  mixins: [instanceable, contextmenuable],
  components: {
    ChartRunning,
    ChartStatus,
    ChartType,
  },
  props: {
    // BEGIN::Added.by.KWShin.2024.02.14.
    statusColors: {
      type: String,
      required: true,
    },
    typeColors: {
      type: String,
      required: true,
    },
    // FINISH::Added.by.KWShin.2024.02.14.
  },
  data() {
    return {
      running: {
        value: 0,
        max: 0,
      },
      status: {
        values: [],
        // BEGIN::Modified.by.KWShin.2024.01.11
        // colors: ['#c23531', '#2f4554', '#61a0a8', '#d48265', '#91c7ae', '#749f83', '#ca8622', '#bda29a', '#6e7074'],
        colors: [],
        colorsDefault: ['#4FC3F7', '#1565C0', '#61A0A8', '#D48265', '#91C7AE', '#749F83', '#CA8622'],
        // FINISH::Modified.by.KWShin.2024.01.11
      },
      type: {
        values: [],
        // BEGIN::Modified.by.KWShin.2024.01.11
        // colors: ['#c23531', '#2f4554', '#61a0a8', '#d48265', '#91c7ae', '#749f83', '#ca8622', '#bda29a', '#6e7074'],
        colors: [],
        colorsDefault: ['#1E88E5', '#EC407A', '#A1887F', '#AB47BC', '#BDBDBD', '#66BB6A'],
        // FINISH::Modified.by.KWShin.2024.01.11
      },
      contextmenuUrl: '/views/detailview/abap/process',
    };
  },
  // BEGIN::Added.by.KWShin.2024.01.11
  // Pie 차트의 색상이 하드코딩 되어 있던 걸,
  // CONF_USER_MTL에서 설정을 읽어와서 적용하도록 기능 추가.
  // Whole.vue에서 한번 읽어와서 인스턴스들에 props로 전파해준다.
  watch: {
    statusColors: {
      immediate: true,
      handler(value) {
        if (!isEmpty(value)) this.status.colors = value.split(',');
        else this.status.colors = this.status.colorsDefault;
      },
    },
    typeColors: {
      immediate: true,
      handler(value) {
        if (!isEmpty(value)) this.type.colors = value.split(',');
        else this.type.colors = this.type.colorsDefault;
      },
    },
  },
  // FINISH::Added.by.KWShin.2024.01.11
  methods: {
    //BEGIN::modified.by.KWShin.2024.03.22.
    /*
    wsBufferedDataHandler(key, responses, every) {
      responses.forEach(response => {
        if (response.length) {
          const last = response[response.length - 1];
          every(key, last.data, last.ctime, last.empty);
        }
      });
    },
    wsDataHandler(key, response) {
      this.running = { value: 0, max: 0 };
      this.status.values = [];
      this.type.values = [];
      response.forEach(res => {
        this.running.max++;
        this.running.value += res.wpIstatus == '4' ? 1 : 0; // wpIstatus == 4 : running

        if (this.status.values.filter(v => v.name == res.wpStatus).length == 0) this.status.values.push({ value: 0, name: res.wpStatus });
        const wpStatus = this.status.values.filter(v => v.name == res.wpStatus)[0];
        wpStatus.value++;

        if (this.type.values.filter(v => v.name == res.wpTyp).length == 0) this.type.values.push({ value: 0, name: res.wpTyp });
        const wpTyp = this.type.values.filter(v => v.name == res.wpTyp)[0];
        wpTyp.value++;
      });
    },
    */
    wsDataHandler(key, response) {
      this.running = { value: 0, max: 0 };
      this.status.values = [];
      this.type.values = [];
      response.forEach(rspn => {
        this.running.max++;
        this.running.value += rspn.wpIstatus == '4' ? 1 : 0; // wpIstatus == 4 : running

        if (this.status.values.filter(v => v.status == rspn.wpIstatus).length == 0) this.status.values.push({ value: 0, status: rspn.wpIstatus });
        const wpStatus = this.status.values.filter(v => v.status == rspn.wpIstatus)[0];
        wpStatus.value += parseInt(rspn.cnt);

        if (this.type.values.filter(v => v.type == rspn.wpItype).length == 0) this.type.values.push({ value: 0, type: rspn.wpItype });
        const wpTyp = this.type.values.filter(v => v.type == rspn.wpItype)[0];
        wpTyp.value += parseInt(rspn.cnt);
      });
      this.status.values.forEach(v => {
        v.name = this.$t(`workprcs.status.${v.status}`);
        switch (v.status) {
          case '2':
            v.colorIndex = 0;
            break;
          case '4':
            v.colorIndex = 1;
            break;
          case '8':
            v.colorIndex = 2;
            break;
          case '16':
            v.colorIndex = 3;
            break;
          case '32':
            v.colorIndex = 4;
            break;
          case '64':
            v.colorIndex = 5;
            break;
          case '128':
            v.colorIndex = 6;
            break;
          default:
            v.colorIndex = 0;
        }
      });
      this.type.values.forEach(v => {
        v.name = this.$t(`workprcs.type.${v.type}`);
        switch (v.type) {
          case '1':
            v.colorIndex = 0;
            break;
          case '2':
            v.colorIndex = 1;
            break;
          case '3':
            v.colorIndex = 2;
            break;
          case '4':
            v.colorIndex = 3;
            break;
          case '5':
            v.colorIndex = 4;
            break;
          case '6':
            v.colorIndex = 5;
            break;
          default:
            v.colorIndex = 0;
        }
      });
    },
    //FINISH::modified.by.KWShin.2024.03.22.
  },
  created() {
    //BEGIN::modified.by.KWShin.2024.03.22.
    /*
    this.$websocket.realtime.send({
      requests: [
        {
          key: { name: 'rawWorkprcs', sstmId: this.instance.systemId, instId: this.instance.id },
          fields: ['wpIstatus', 'wpStatus', 'wpTyp'],
          empty: false,
          handler: {
            buffer: this.wsBufferedDataHandler,
            every: this.wsDataHandler,
          },
        },
      ],
    });
    */
    this.$websocket.realtime.send({
      requests: [
        {
          key: { name: 'cntWorkprcsTypeStatus', sstmId: this.instance.systemId, instId: this.instance.id },
          fields: ['wpItype', 'wpIstatus', 'cnt'],
          empty: false,
          handler: {
            every: this.wsDataHandler,
          },
        },
      ],
    });
    //FINISH::modified.by.KWShin.2024.03.22.
  },
};
</script>
